import videoService from "@/api/services/videoService";
import { MiddlewareInterface } from "@/interfaces/Middleware.ts";

export default async ({ to, redirect }: MiddlewareInterface) => {
  if (to.path !== "/free-video") {
    return true;
  }

  if (to.query.token) {
    try {
      const videos = await videoService.setUnlockedVideos(to.query.token as string);

      if (videos.length > 0) {
        const video = videos[0];

        const uri = `/shoot/${video.gallery.id}#video-${video.id}`;
        redirect(uri);
        return;
      }
    } catch {
      // ignore
    }
  }

  redirect("/recent_updates");
};
